export default "__VITE_ASSET__DLdkGF2$__"